module.exports = __webpack_public_path__ + "img/小雨.00fd0679.png";